import { useQuery } from 'react-query';
import { lovageApi } from 'src/axios';

export interface VoicemailSettings {
  // agent language variant id
  alv_id: number;
  agent_language_code: string;
  send_notifications: boolean;
  voicemail_email_addresses: string[];
}

export interface GetVoicemailSettingsRequest {
  location_id: number | null;
}

export const fetchVoicemailSettings = ({ location_id }: GetVoicemailSettingsRequest) =>
  lovageApi
    .get<VoicemailSettings[]>(`/dashboard/voicemail/settings`, { params: { location_id } })
    .then((res) => res.data);

export const baseQueryKey = 'voicemailSettings';

export default function useVoicemailSettings(req: GetVoicemailSettingsRequest) {
  const queryKey = [baseQueryKey, req.location_id];

  return useQuery(queryKey, () => fetchVoicemailSettings(req), {
    // Only fetch if location_id is not null
    enabled: !!req.location_id,
  });
}
